import { openBlock as s, createElementBlock as n, createStaticVNode as v, defineComponent as V, ref as w, computed as i, getCurrentInstance as b, inject as x, normalizeClass as S, mergeProps as A, Fragment as E, renderList as $, createElementVNode as H, createVNode as z, unref as P, renderSlot as F, createCommentVNode as I } from "vue";
import { _ as Z } from "./_plugin-vue_export-helper.dad06003.js";
const T = (t) => t ? t.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase() : "";
var d = /* @__PURE__ */ ((t) => (t.Landscape = "landscape", t.Portrait = "portrait", t))(d || {}), m = /* @__PURE__ */ ((t) => (t.Desktop = "", t.Laptop = "(max-width: 1441px)", t.LaptopSm = "(max-width: 1280px)", t.Tablet = "(max-width: 1024px)", t.TabletSm = "(max-width: 768px)", t.Mobile = "(max-width: 563px)", t))(m || {});
const j = {}, B = {
  class: "is-inside-mask",
  width: "478",
  height: "478",
  viewBox: "0 0 478 478",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, G = /* @__PURE__ */ v('<mask id="mask0_4_5" style="mask-type:luminance;" maskUnits="userSpaceOnUse" x="9" y="76" width="458" height="321"><path d="M466.624 76.48H9.56006V396.979H466.624V76.48Z" fill="white"></path></mask><g mask="url(#mask0_4_5)"><path class="coloredPathGrey50" d="M294.831 154.49C287.948 164.48 281.543 170.885 271.552 177.768C269.545 179.154 269.545 182.07 271.552 183.456C281.543 190.34 287.948 196.745 294.831 206.735C296.217 208.743 299.133 208.743 300.519 206.735C307.402 196.745 313.808 190.34 323.798 183.456C325.805 182.07 325.805 179.154 323.798 177.768C313.808 170.885 307.402 164.48 300.519 154.49C299.133 152.482 296.217 152.482 294.831 154.49Z"></path><path class="coloredPathGrey50" d="M457.064 396.979H19.1201C13.8621 396.979 9.56006 392.677 9.56006 387.419V86.04C9.56006 80.782 13.8621 76.48 19.1201 76.48H457.064C462.322 76.48 466.624 80.782 466.624 86.04V387.419C466.624 392.677 462.322 396.979 457.064 396.979ZM47.8001 358.739H428.384V114.72H47.8001V358.739Z"></path><path class="coloredPathGrey40" d="M340.765 229.105L295.116 262.374L184.698 156.545C181.066 153.056 175.377 153.008 171.697 156.354L70.2173 248.034C68.2097 249.851 67.0625 252.432 67.0625 255.109V291.628C67.0625 295.786 71.9859 297.937 75.0451 295.165L177.528 202.576L286.034 306.541C289.38 309.744 294.543 310.079 298.271 307.354L346.071 272.508L401.471 314.667C404.626 317.057 409.167 314.811 409.167 310.843V277.192C409.167 274.229 407.781 271.408 405.391 269.592L352.237 229.153C348.891 226.572 344.207 226.524 340.813 229.058L340.765 229.105Z"></path></g>', 2), N = [
  G
];
function D(t, c) {
  return s(), n("svg", B, N);
}
const M = /* @__PURE__ */ Z(j, [["render", D]]), U = ["srcset", "media", "type"], K = ["src", "alt", "loading"], q = {
  key: 1,
  class: "FrontiersImage"
}, J = ["innerHTML"], O = { key: 3 }, W = /* @__PURE__ */ V({
  __name: "FrontiersImage",
  props: {
    sources: {},
    imageAlt: { default: "" },
    figcaption: { default: "" },
    orientation: { default: "Landscape" },
    lazyLoadingAttr: { type: Boolean, default: !1 },
    onClick: {},
    onClickAriaLabel: {}
  },
  emits: ["error", "load"],
  setup(t, { emit: c }) {
    const o = t, l = w(!1), u = i(() => {
      const e = o.sources[o.sources.length - 1];
      return typeof e == "string" ? e : e.src;
    }), g = i(() => {
      if (!o.onClick)
        return {};
      const e = b(), a = e == null ? void 0 : e.appContext.config.globalProperties.$ga, r = o.onClickAriaLabel ? o.onClickAriaLabel : "";
      return {
        "data-event": a == null ? void 0 : a.getDataEventValue(
          "FrontiersImage",
          "click",
          T(r)
        ),
        role: "button",
        "aria-label": r
      };
    }), h = i(() => o.lazyLoadingAttr ? "lazy" : "eager"), f = i(() => {
      const e = [];
      return o.sources.forEach((a) => {
        if (typeof a != "string") {
          e.push(a);
          return;
        }
        const r = a.split(".").pop() || "jpg";
        let p = `image/${r}`;
        (p.includes("jpg") || r.length > 4) && (p = "image/jpeg");
        const y = {
          src: a,
          media: m.Desktop,
          type: p
        };
        a !== u.value && e.push(y);
      }), e;
    }), C = i(() => d[o.orientation] === "portrait"), k = () => {
      l.value = !0, c("error");
    }, _ = () => {
      c("load");
    }, L = x("sanitize");
    return (e, a) => (s(), n("figure", {
      class: S(["FrontiersImage", {
        "FrontiersImage--portrait": C.value,
        "FrontiersImage--error": l.value
      }])
    }, [
      l.value ? (s(), n("picture", q, [
        z(M)
      ])) : (s(), n("picture", A({
        key: 0,
        class: ["FrontiersImage", {
          "FrontiersImage--hasClickEvent": !!e.onClick
        }]
      }, g.value, {
        onClick: a[0] || (a[0] = //@ts-ignore
        (...r) => e.onClick && e.onClick(...r))
      }), [
        (s(!0), n(E, null, $(f.value, (r) => (s(), n("source", {
          key: r.src,
          srcset: r.src,
          media: r.media,
          type: r.type
        }, null, 8, U))), 128)),
        H("img", {
          src: u.value,
          class: "is-inside-mask",
          alt: e.imageAlt,
          loading: h.value,
          onError: k,
          onLoad: _
        }, null, 40, K)
      ], 16)),
      e.figcaption ? (s(), n("figcaption", {
        key: 2,
        innerHTML: P(L)(e.figcaption)
      }, null, 8, J)) : e.$slots.figcaption ? (s(), n("figcaption", O, [
        F(e.$slots, "figcaption")
      ])) : I("", !0)
    ], 2));
  }
});
export {
  d as F,
  W as _,
  m as a,
  T as t
};
